(() => {
  const root = document.querySelector('.ryze-018-v02');
  if (!root) return;

  const purchaseAnchor = document.getElementById('ryze-018-official-purchase');

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ryze-buy]');
    if (!trigger || !document.body.contains(root)) return;
    event.preventDefault();

    const releasit = document.getElementById('_rsi-buy-now-button');
    if (releasit) {
      releasit.click();
      return;
    }

    if (purchaseAnchor) {
      purchaseAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  const conveyor = document.querySelector('.ryze-018-v03__carrier-conveyor');
  if (!conveyor) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => conveyor.classList.toggle('is-in-view', entry.isIntersecting));
    }, { rootMargin: '120px 0px', threshold: 0.05 });
    observer.observe(conveyor);
  } else {
    conveyor.classList.add('is-in-view');
  }
})();
